
import Utils from '@/common/utils.js'
import ShowMessage from '@/components/messages/ShowMessage.js'
import ClinicalService from '@/services/clinical.service'
import ExpressionParser from '@/common/ExpressionParser'

export default {
    mixins: [ShowMessage,Utils,ExpressionParser],

    data() {
        return {
            usersFunction: [],
            variables: [], 
            functions: [
                {
                    name: 'GetTimeDuration', 
                    countOfParameters: 4,
                    handle: this.getTimeDurationExpBuilder
                },
                {
                    name: 'ExecuteMultiLinesQuery', 
                    countOfParameters: 7,
                    handle: this.executeMultiLinesQueryExpBuilder
                },
                {
                    name: 'GetLookUpValue', 
                    countOfParameters: 3,
                    handle: this.getLookUpValueExpBuilder
                },
                {
                    name: 'SetControlValueItemsByName', 
                    countOfParameters: 2,
                    handle: this.setControlValueItemsByNameExpBuilder
                },
                {
                    name: 'SetControlValueByName', 
                    countOfParameters: 2,
                    handle: this.setControlValueByNameExpBuilder
                },
                {
                    name: 'GetControlValueByName', 
                    countOfParameters: 1,
                    handle: this.getControlValueByNameExpBuilder
                },
                {
                    name: 'GetListBoxCheckedCount', 
                    countOfParameters: 1,
                    handle: this.getListBoxCheckedCountExpBuilder
                },
                {
                    name: 'GetDSMVBySubstanceNCount', 
                    countOfParameters: 3,
                    handle: this.getDSMVBySubstanceNCountExpBuilder
                },
                {
                    name: 'UpdateWorkflowStatus', 
                    countOfParameters: 4,
                    handle: this.updateWorkflowStatusExpBuilder
                },
                {
                    name: 'TextContainsValue', 
                    countOfParameters: 3,
                    handle: this.textContainsValueExpBuilder
                }
            ],
            lookUpValue: '',
            dsmvValues: ''
        }
    },

    methods: {
        addStringVariable(name, value) {
            let element = this.getUserVariable(name);
            if (element) {
                element.data = value ? `${value}`.trim() : '';
            } else {
                this.variables.push({
                    typ: 'string',
                    name: name.toUpperCase(),
                    data: value ? `${value}`.trim() : ''
                });
            }
        },

        addNumericVariable(name, value) {
            let element = this.getUserVariable(name);
            if (element) {
                element.data = value;
            } else {
                this.variables.push({
                    typ: 'number',
                    name: name.toUpperCase(),
                    data: value
                });
            }
        },

        getVariableValue(name) {
            const element = this.getUserVariable(name);
            if (element) {
                return element.data;
            }
        },

        getUserVariable(name) {
            const upperName = name.toUpperCase();
            return this.variables.find(element => element.name == upperName);
        },

        addUserFunction(name, countOfParameters, handle) {
            this.usersFunction.push({
                name, 
                countOfParameters,
                handle
            });
        },

        getUserFunctionHandleByName(name) {
            const userFunc = this.usersFunction.find(element => element.name == name);
            if (userFunc) {
                return userFunc.handle;
            } 
        },

        setControlValueByNameHandle() {
            return this.getUserFunctionHandleByName('SetControlValueByName');
        },

        getControlValueByNameHandle() {
            return this.getUserFunctionHandleByName('GetControlValueByName');
        },

        getListBoxCheckedCountHandle() {
            return this.getUserFunctionHandleByName('GetListBoxCheckedCount');
        },

        setControlValueItemsByNameHandle() {
            return this.getUserFunctionHandleByName('SetControlValueItemsByName');
        },

        textContainsValueHandle() {
            return this.getUserFunctionHandleByName('TextContainsValue');
        },

        resolvedVariables(value) {
            this.variables.forEach((element) => {
                value = value.replaceAll(new RegExp(element.name, 'gi'), `'${element.data}'`);
                value = value.replaceAll('\r\n', ';');
            });
            
            return value;
        },

        async computeNodeIf(node) {
            let position = 0;
            const tokens = [];
            while (position < node.conditions.length) {
                let token = node.conditions[position];
                position++;
                if (Utils.equalsIgnoringCase(token.key, 'TextContainsValue') || 
                    Utils.equalsIgnoringCase(token.key, 'GetControlValueByName')) {
                    const funcName = token.key;
                    let opens = 0;
                    const parameters = [];
                    while (position < node.conditions.length) {
                        token = node.conditions[position];
                        position++;

                        parameters.push(token.value)
                        if (token.key == '(') {
                            opens = opens + 1;
                        } else if (token.key == ')') {
                            opens = opens - 1;
                            if (opens == 0)
                                break;
                        }
                    }
                    
                    const expression = `${funcName}${parameters.join("")}`;
                    const value = await this.evaluateSubExpression(expression);
                    tokens.push(`'${value}'`);
                } else if (token.key == '=') {
                    tokens.push('==');
                } else if (token.key == '<>') {
                    tokens.push('!=');
                } else if (token.key.toUpperCase() == 'AND') {
                    tokens.push('&&');
                } else if (token.key.toUpperCase() == 'OR') {
                    tokens.push('||');
                } else {
                    tokens.push(token.key);
                }
            }

            const body = `return ${tokens.join("")}`;
            const functionHandle = new Function(body);
            if (functionHandle()) {
                node.body.forEach(this.computeNode);
            }
        },

        computeNodeStatement(node) {
            const expression = `${node.name}${node.params.map(x => x.value).join("")}`;
            this.evaluateExpressionWithoutCode(expression);
        },

        async computeNode(node) {
            if (node.type == 'IfStatement') {
                await this.computeNodeIf(node);
            } else if (node.type == 'Statement') {
                this.computeNodeStatement(node);
            }
        },

        async computeCode(ast) {
            for (let index = 0; index < ast.length; index++) {
                const node = ast[index];
                await this.computeNode(node);
            }
        },

        evaluateExpressionByEvent(eventExpression) {
            if (eventExpression && eventExpression.trim() != "") {
                if (eventExpression.indexOf('begin') == 0) {
                    this.evaluateExpression(eventExpression);
                } else {
                    const expressions = eventExpression.split('\r\n');
                    expressions.forEach(element => {
                        this.evaluateExpression(element);
                    });
                }
            }
        },

        evaluateExpression(expression) {
            const event = expression.trim();
            if (event.indexOf('begin') == 0) {
                this.evaluateExpressionWithCode(event);
            } else {
                this.evaluateExpressionWithoutCode(event);
            }
        },

        async evaluateExpressionWithCode(expression) {
            const astCode = this.compile(this.resolvedVariables(expression));
            await this.computeCode(astCode);
        },

        async evaluateExpressionWithoutCode(expression) {
            const event = expression.trim();
            if (event && event.trim() != "") {
                const posStart = event.indexOf('(');
                const posLast = event.lastIndexOf(')');

                if (posStart > 0 && posLast > 0) {
                    let vars = [];
                    //let vals = [];
                    const parameters = this.commaText(event.substr(posStart + 1, posLast - (posStart + 1)).trim());
                    const func =  event.substr(0, posStart);
                    for (let index = 0; index < parameters.length; index++) {
                        const parameter = parameters[index].trim();
                        if (parameter.indexOf('(') > 0 && parameter.lastIndexOf(')') > 0) {
                            const value = await this.evaluateSubExpression(parameter);
                            vars.push({ 
                                typ: 'string', 
                                str: value
                            });
                        } else if (parameter.indexOf('\'') == 0) {
                            vars.push({ 
                                typ: 'string', 
                                str: parameter.replaceAll('\'', '') 
                            });
                        } else {
                            const userVariable = this.getUserVariable(parameter);
                            vars.push({ 
                                typ: 'string', 
                                str: userVariable?.data
                            });
                        }
                    }

                    this.computeString(func, parameters.length, vars);
                }
            }
        },

        async evaluateSubExpression(expression) {
            const event = expression.trim();
            if (event && event.trim() != "") {
                const posStart = event.indexOf('(');
                const posLast = event.lastIndexOf(')');

                if (posStart > 0 && posLast > 0) {
                    let vars = [];
                    const parameters = this.commaText(event.substr(posStart + 1, posLast - (posStart + 1)).trim());
                    const func =  event.substr(0, posStart);                    
                    parameters.forEach(element => {
                        const parameter = element.trim();
                        if (parameter.indexOf('\'') == 0) {
                            vars.push({ 
                                typ: 'string', 
                                str: parameter.replaceAll('\'', '') 
                            });
                        } /*else {
                            
                        }*/
                    });

                    return await this.computeString(func, parameters.length, vars);
                }
            }
        },

        commaText(value) {
            let parameters = [];
            const length = value.length;
            let position = 0;
            let nextPosition = 0;
            while (position < length) {
                if (value[position] == ',' || value[position] == ' ') {
                    position++;
                    continue;
                } 
                
                if (value[position] == "'") {
                    nextPosition = value.indexOf("'", position + 1);
                    if (nextPosition == -1) {
                        parameters.push(value.substr(position));
                        break;
                    }
                    parameters.push(value.substr(position, (nextPosition - position) + 1));
                    position += (nextPosition - position) + 1;
                    continue;
                }

                if (value[position] == '"') {
                    nextPosition = value.indexOf('"', position + 1);
                    if (nextPosition == -1) {
                        parameters.push(value.substr(position + 1));
                        break;
                    }
                    parameters.push(value.substr(position + 1, nextPosition - (position + 1)));
                    position += (nextPosition - position) + 1;
                    continue;
                }

                nextPosition = value.indexOf(',', position);
                if (nextPosition == -1) {
                    parameters.push(value.substr(position));
                    break;
                }
                parameters.push(value.substr(position, nextPosition - (position)));
                position += (nextPosition - position);
            }
            
            return parameters;
        },

        async computeString(func, countOfParameters, parameters) {
            const userFunc = this.functions.find(element => element.name == func);
            if (userFunc && userFunc.handle && userFunc.countOfParameters == countOfParameters) {
                return await userFunc.handle(parameters);
            }
        },

        getTimeDurationExpBuilder(parameters) {
            const durationUnit       = parameters[0].str;
            const controlOfTimeFrom  = parameters[1].str;
            const controlOfTimeTo    = parameters[2].str;
            const destinationControl = parameters[3].str;

            const functionHandle = this.setControlValueByNameHandle();
            if (functionHandle) {
                const result = this._getTimeDuration(durationUnit, controlOfTimeFrom, controlOfTimeTo);
                if (result != undefined) {
                    functionHandle(destinationControl, result);
                }
            }
        },

        _getTimeDuration(durationUnit, controlOfTimeFrom, controlOfTimeTo) {
            const functionHandle = this.getControlValueByNameHandle();
            let result = '';
            if (functionHandle) {
                const format = 'hh:mm A';
                const startTimeStr = functionHandle(controlOfTimeFrom)?.trim();
                const endTimeStr   = functionHandle(controlOfTimeTo)?.trim();
                if (!Utils.isNullOrEmptyString(startTimeStr) && !Utils.isNullOrEmptyString(endTimeStr))
                {
                    const validStartTime = Utils.isValidTime(startTimeStr);
                    const validEndTime = Utils.isValidTime(endTimeStr);
                    if (!validStartTime) {
                        this.showMessage(this.$t('Msg.Warning'), this.$t('ExpressionBuilder.InvalidStartTime'), 'warning');
                    } else if (!validEndTime) {
                        this.showMessage(this.$t('Msg.Warning'), this.$t('ExpressionBuilder.InvalidEndTime'), 'warning');
                    } else {
                        const duration = durationUnit.toUpperCase();
                        if (duration == "M") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'minutes');
                        } else if (duration == "H") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'hours');
                        } else if (duration == "S") {
                            result = Utils.diffBetween(startTimeStr, endTimeStr, format, 'seconds');
                        } else {
                            this.showMessage(this.$t('ExpressionBuilder.Title'), this.$t('ExpressionBuilder.DurationNotImplemented'));
                        }
                    }
                }
            }

            return result;
        },

        async executeMultiLinesQueryExpBuilder(parameters) {
            const controlName = parameters[0].str;
            const queryParameters = {
                viewName: parameters[1].str,
                fieldName: parameters[2].str,
                conditions: [
                    parameters[3].str,
                    parameters[4].str,
                    parameters[5].str,
                    parameters[6].str
                ].filter(x => x.trim().length > 0),
                selfValue: this.getVariableValue('SelfValue'),
                recordID: this.getVariableValue('RecordID'),
                txHeaderID: this.getVariableValue('TXHeaderID')
            }
            
            await ClinicalService.setTokenConditionValues(queryParameters)
                    .then((response) => { 
                        let values = [];
                        if(response.data && response.data.length > 0) {
                            values = response.data.filter(x => x.trim().length != 0);
                        }

                        const functionHandle = this.setControlValueItemsByNameHandle()
                        if (functionHandle) {
                            functionHandle(controlName, values);
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });          
        },

        updateWorkflowStatusExpBuilder(parameters) {
            const queryParameters = {
                patientCode: parameters[0].str,
                incidentID: parameters[1].str,
                processID: parameters[2].str,
                workflowID: parameters[3].str
            }
            
            ClinicalService.updateWorkflowStatus(queryParameters)
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
        },

        async getDSMVBySubstanceNCountExpBuilder(parameters) {
            const controlNameHandle = this.getControlValueByNameHandle();
            const listBoxCheckHandle = this.getListBoxCheckedCountHandle();
            if (controlNameHandle && listBoxCheckHandle) {
                const queryParameters = {
                    lookUpTableName: parameters[0].str,
                    countValue: listBoxCheckHandle(parameters[2].str),
                    substanceValue: controlNameHandle(parameters[1].str)
                }

                this.dsmvValues = '';
                await ClinicalService.getDSMVValues(queryParameters)
                    .then((response) => { 
                        if(response.data && response.data.length > 0) {
                            this.dsmvValues = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }

            return this.dsmvValues;
        },

        getListBoxCheckedCountExpBuilder(parameters) {
            const controlName = parameters[0].str;

            const functionHandle = this.getListBoxCheckedCountHandle();
            if (functionHandle) {
                return functionHandle(controlName);
            }
        },

        getControlValueByNameExpBuilder(parameters) {
            const controlName = parameters[0].str;
            
            const functionHandle = this.getControlValueByNameHandle();
            if (functionHandle) {
                return functionHandle(controlName);
            }
        }, 

        setControlValueByNameExpBuilder(parameters) {
            const controlName = parameters[0].str;
            const controlValue = parameters[1].str;
            
            const functionHandle = this.setControlValueByNameHandle();
            if (functionHandle) {
                functionHandle(controlName, controlValue);
            }
        }, 

        setControlValueItemsByNameExpBuilder(parameters) {
            const controlName = parameters[0].str;
            const controlValue = parameters[1].str;
            
            const functionHandle = this.setControlValueItemsByNameHandle();
            if (functionHandle) {
                functionHandle(controlName, controlValue);
            }
        }, 

        async getLookUpValueExpBuilder(parameters) {
            const queryParameters = {
                selfValue: this.getVariableValue('SelfValue').trim(),
                lookUpTable: parameters[0].str,
                lookUpColumn: parameters[1].str,
                returnColumn: parameters[2].str
            }

            this.lookUpValue = '';
            await ClinicalService.getLookUpValue(queryParameters)
                    .then((response) => { 
                        if(response.data && response.data.length > 0) {
                            this.lookUpValue = response.data;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });

            return this.lookUpValue;
        },

        textContainsValueExpBuilder(parameters) {
            const value = parameters[0].str;
            const text = parameters[1].str;
            const separator = parameters[2].str;
            
            const functionHandle = this.textContainsValueHandle();
            if (functionHandle) {
                return functionHandle(value, text, separator);
            }
        }
    }
}